<template>
  <v-container
    id="lock"
    class="fill-height"
    tag="section"
  >
    <v-row justify="center">
      <v-slide-y-transition appear>
        <v-card
          class="mt-6 mt-md-0"
          light
          max-width="100%"
          width="250"
        >
          <v-card-text
            class="text-center"
            style="background-color: white !important"
          >
            <v-avatar
              class="mt-n12 mb-6 elevation-12"
              color="grey"
              size="88"
            >
              <v-icon
                x-large
              >
                mdi-lock-open-outline
              </v-icon>
            </v-avatar>

            <div
              class="display-2 font-weight-light mb-3 text--darken-2 grey--text"
            >
              Goodbye
            </div>
          </v-card-text>
        </v-card>
      </v-slide-y-transition>
    </v-row>
  </v-container>
</template>

<script>
  import { mapActions } from 'vuex'

  export default {
    name: 'PagesLogout',

    created () {
      this.removeOidcUser()
    },

    methods: {
      ...mapActions('oidcStore', [
        'removeOidcUser',
      ]),
    },
  }
</script>
